import type { Location } from "../../shared/types.js";

export function populateLocationPicker(
  selectEl: HTMLSelectElement,
  locations: Location[]
): void {
  selectEl.replaceChildren();
  for (const loc of locations) {
    const opt = document.createElement("option");
    opt.value = loc.id;
    opt.textContent = loc.name;
    selectEl.appendChild(opt);
  }
}
